/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFillFileMp3 = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 2.5H2v19h20zm-14 6 6-4v15l-6-4H4v-7zm9.449 3.485c0 1.443-.533 2.68-1.599 3.71l-1.075-1.113c.737-.742 1.106-1.618 1.106-2.628 0-1.031-.369-1.928-1.106-2.691L15.85 8.15c1.046 1.051 1.578 2.33 1.599 3.834zM20 11.923c0 2.185-.768 4.062-2.305 5.629l-1.138-1.145c1.23-1.216 1.845-2.706 1.845-4.469s-.615-3.263-1.845-4.5l1.138-1.113C19.232 7.87 20 9.737 20 11.923z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFillFileMp3 as FillFileMp3 };
